import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AuthenticationService } from "app/auth/service";
import { UtilsService } from "app/auth/service/utils.service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { IRating } from "../../models/ratings";
import { RatingsService } from "../../ratings.service";

@Component({
  selector: "app-candidate-ratings-list",
  templateUrl: "./candidate-ratings-list.component.html",
})
export class CandidateRatingsListComponent implements OnInit {
  public tableLimit: number = 10;
  public searchKeyword: string = "";
  public contentHeader: IContentHeader;
  public ratings: IRating = {
    name: null,
    color: null,
  };
  public ratingsList: IRating[] = [];
  public filteredRatingList: IRating[] = [];
  public showModalError: boolean = false;

  constructor(
    public _modalService: NgbModal,
    public _utilService: UtilsService,
    public _authenticationService: AuthenticationService,
    private router: Router,
    public _ratingsService: RatingsService,
  ) {
    this.contentHeader = {
      headerTitle: "MENU.RATING_CANDIDATE",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "MENU.MANAGE",
            isLink: true,
            link: "/dashboard/platform-management",
          },
          {
            name: "MENU.RATING_CANDIDATE",
            isLink: false,
          },
        ],
      },
    };
  }

  async ngOnInit() {
    if (!this._authenticationService.hasCapability("show_menu_candidate_ratings_list")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    await this.load();
  }

  async load() {
    this.ratingsList = await this._ratingsService.getList();
    this.filter();
  }

  updateTableLimit(event: { target: { value: string } }) {
    this.tableLimit = Number(event.target.value);
  }

  filter() {
    let items: IRating[] = this.ratingsList;
    const keywords: string = this.searchKeyword.trim().toLowerCase();

    if (keywords.length > 0) {
      items = this.ratingsList.filter((item: IRating) => item.name.toLowerCase().includes(this.searchKeyword.trim().toLowerCase()));
    }

    this.filteredRatingList = items;
  }

  public modalOpen(whichModal, ratings: IRating) {
    this.showModalError = false;
    this.ratings = {
      name: null,
      color: null,
    };
    if (!!ratings) {
      this.ratings = {
        id: ratings.id,
        name: ratings.name,
        color: ratings.color,
      };
    }
    this._modalService.open(whichModal, {
      size: "sm",
      centered: true,
    });
  }

  isError(): boolean {
    if (!this.ratings.name || this.ratings.name.trim() === "" || this.ratings.name.length < 1 || !this.ratings.color) {
      this.showModalError = true;
      return true;
    }
  }

  async delete(currentItem: { name: string; id?: number }) {
    if (!this._authenticationService.hasCapability("delete_candidate_ratings")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }

    let deleteText: string = await this._utilService.translate("ALERT.CONFIRM_DELETE_TEXT");
    deleteText += await this._utilService.translate("ALERT.CONFIRM_DELETE_THIS_OBJECT");
    deleteText += currentItem.name;

    await this._utilService.showSWALDeleteConfirmation({ text: deleteText }).then(async (result) => {
      if (result.value) {
        await this._ratingsService
          .delete(currentItem.id)
          .then(async () => {
            await this._utilService.showPopupItemDeleted().then(async () => {
              await this.load();
            });
          })
          .catch(() => this._utilService.showSWALError({ text: "ERROR_DELETE_RATING" }));
      } else if (result.isDismissed) {
        await this._utilService.showSWALError({
          title: "ABORTED_TITLE",
          text: "ABORTED_TEXT",
        });
      }
    });
  }

  async add() {
    if (!this._authenticationService.hasCapability("create_candidate_ratings")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }

    if (this.isError()) {
      this._utilService.showSWALError({ text: "SELECT_NAME_OR_COLOR" });
      return false;
    }

    const data: IRating = {
      name: this.ratings.name.trim(),
      color: this.ratings.color,
    };

    this._utilService.showLoading();
    await this._ratingsService
      .create(data)
      .then(() => {
        this.load();
        this._modalService.dismissAll();
        this._utilService.hideLoading();
        this.filter();
        this._utilService.showSWALSuccess({ text: "SUCCESS_CREATE_RATING" });
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR__CREATE_RATING" });
      });
  }

  async edit() {
    if (!this._authenticationService.hasCapability("edit_candidate_ratings")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }

    if (this.isError()) {
      this._utilService.showSWALError({ text: "SELECT_NAME_OR_COLOR" });
      return false;
    }

    const data: IRating = {
      name: this.ratings.name.trim(),
      color: this.ratings.color,
    };

    this._utilService.showLoading();
    await this._ratingsService
      .update(this.ratings.id, data)
      .then(() => {
        this._utilService.hideLoading();
        this.load();
        this.filter();
        this._modalService.dismissAll();
        this._utilService.showSWALSuccess({ text: "SUCCESS_EDIT_RATING" });
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_EDIT_RATING" });
      });
  }
}
